import { defineStore } from 'pinia'
import { ref } from 'vue'
import api from '../lib/api'

export const useInscricoesStore = defineStore('inscricoes', () => {
  const items = ref([])
  const meta = ref({ total: 0, page: 1, limit: 30, pages: 1 })
  const loading = ref(false)

  async function fetch(params = {}) {
    loading.value = true
    try {
      const { data } = await api.get('/inscricoes', { params })
      items.value = data.inscricoes
      meta.value = data.meta
    } finally { loading.value = false }
  }

  async function getOne(id) {
    const { data } = await api.get(`/inscricoes/${id}`)
    return data.inscricao
  }

  async function updateAnotacao(id, anotacao) {
    const { data } = await api.patch(`/inscricoes/${id}/anotacao`, { anotacao })
    items.value = items.value.map(i => i.id === id ? { ...i, anotacao: data.inscricao.anotacao } : i)
  }

  /**
   * Corrige a faixa e nada mais: a API nao recalcula cobranca, entao a lista
   * de pagamentos que ja estiver na tela continua valendo.
   */
  async function corrigirTipo(id, tipoInscricao) {
    const { data } = await api.patch(`/inscricoes/${id}/tipo`, { tipoInscricao })
    return data
  }

  async function exportarLista(eventoSlug) {
    const { data } = await api.get('/inscricoes/exportar', { params: { eventoSlug } })
    return data
  }

  async function sync(id) {
    const { data } = await api.post(`/inscricoes/${id}/sync`)
    return data
  }

  async function cancelar(id) {
    const { data } = await api.post(`/inscricoes/${id}/cancelar`)
    return data
  }

  async function reenviarConfirmacao(id, tipo = 'auto') {
    const { data } = await api.post(`/inscricoes/${id}/reenviar-confirmacao`, { tipo })
    return data
  }

  function applyPusherUpdate({ inscricaoId, statusPagamento }) {
    items.value = items.value.map(i =>
      i.id === inscricaoId ? { ...i, statusPagamento } : i
    )
  }

  return { items, meta, loading, fetch, getOne, updateAnotacao, corrigirTipo, exportarLista, sync, cancelar, reenviarConfirmacao, applyPusherUpdate }
})
